import type { ModelFilterStateType } from "../reducers/ModelFilterReducer";
import type {
    FilterInfoType,
    ModelFilterGradeType,
    ModelFilterCarType,
} from "../../../../../common-deprecated/types/CommonTypes";

export const SET_MODEL_FILTER_VALUE = "modelFilter/setModelFilterValue" as const;
export const SET_FILTERED_GRADES = "modelFilter/setFilteredGrades" as const;
export const INIT_MODEL_FILTER = "modelFilter/init" as const;
export const SET_MODEL_FILTER_DATA = "modelFilter/setData" as const;

type ModelFilterExtraValuesType = {
    filterValues?: { [index: string]: string };
    filteredGrades?: ModelFilterCarType[];
};

export type InitModelFilterType = { type: typeof INIT_MODEL_FILTER } & ModelFilterExtraValuesType;
export const initModelFilter = (): InitModelFilterType => ({ type: INIT_MODEL_FILTER });

export type SetModelFilterType = {
    type: typeof SET_MODEL_FILTER_VALUE;
    filterCode: string;
    value: string;
} & ModelFilterExtraValuesType;
export const setModelFilterValue = (filterCode: string, value: string): SetModelFilterType => ({
    type: SET_MODEL_FILTER_VALUE,
    value,
    filterCode,
});

export type SetFilteredGradesType = {
    type: typeof SET_FILTERED_GRADES;
    filterCode: string;
    filteredGrades: ModelFilterGradeType[];
    dimensions?: ModelFilterStateType["dimensions"];
};
export const setFilteredGrades = (
    filteredGrades: ModelFilterGradeType[],
    filterCode: string = "",
): SetFilteredGradesType => ({
    type: SET_FILTERED_GRADES,
    filteredGrades,
    filterCode,
});

type SetModelFilterDataType = {
    type: typeof SET_MODEL_FILTER_DATA;
    name: string;
    internalCode: string;
    cars: FilterInfoType["cars"];
    filters: FilterInfoType["filters"];
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const setModelFilterData = (
    name: string,
    internalCode: string,
    cars: FilterInfoType["cars"],
    filters: FilterInfoType["filters"],
): SetModelFilterDataType => ({
    type: SET_MODEL_FILTER_DATA,
    name,
    internalCode,
    cars,
    filters,
});

export type ModelFilterActionsType =
    | InitModelFilterType
    | SetModelFilterType
    | SetFilteredGradesType
    | SetModelFilterDataType;
